import * as yup from 'yup';
import { TranslateFn } from '../../library/validationRules';
import ResourcesIds from '../../resources/ResourcesIds';

/**
 * What the staff half of the reschedule dialog holds while it is being filled in.
 *
 * One field, because a move changes when it happens and nothing else: the length is
 * carried over from the appointment rather than re-asked, so it cannot drift from the
 * service that was sold.
 */
export interface RescheduleFormValues {
    /** Local wall clock, as `AppDateTimePicker` reads and writes it. */
    startsAt: string;
}

/**
 * Deliberately *not* bounded by the clinic's or the therapist's program.
 *
 * Staff may book whenever they need to -- an emergency at eight in the evening is a real
 * thing -- and moving one is no different, which is exactly why the API applies its
 * availability rule to a patient's move alone. `createNewEntrySchema` leaves the same
 * field unbounded for the same reason.
 *
 * The patient half of the dialog has no schema at all: it picks from windows the API has
 * already said are free, so there is nothing left for a rule here to judge.
 */
export const createRescheduleSchema = (translate: TranslateFn) => yup.object({
    startsAt: yup.string()
        .required(translate(ResourcesIds.APPOINTMENT_RESCHEDULE_STARTS_AT_REQUIRED)),
});
